export type LoadingActionType = {
  type?: string
}

export type LoadingType = {
  autoLoading: boolean
}

/************************************
 * ACTION TYPE
 ************************************/
export const REDUX_AUTO_LOADING = "REDUX_AUTO_LOADING"
export const REDUX_MANUAL_LOADING = "REDUX_MANUAL_LOADING"

/************************************
 * ACTIONS
 ************************************/
export const setAutoLoading = () => {
  return {
    type: REDUX_AUTO_LOADING,
  }
}

export const setManualLoading = () => {
  return {
    type: REDUX_MANUAL_LOADING,
  }
}

/************************************
 * REDUCER
 ************************************/
const initialState: LoadingType = {
  autoLoading: true,
}

export default (
  state: LoadingType = initialState,
  action: LoadingActionType
) => {
  switch (action.type) {
    case REDUX_AUTO_LOADING:
      return {
        ...state,
        autoLoading: true,
      }
    case REDUX_MANUAL_LOADING:
      return {
        ...state,
        autoLoading: false,
      }
    default:
      return state
  }
}
